export const PCOM_ROUTES = {
  RESET_PASSWORD: 'resetpassword',
  HOME: 'home',
  SHELL_FLOTA: 'shellflota',
  REEMBOLSO_EXPRESS: 'reembolsoexpress',
  CAMBIAR_COMERCIO: 'cambiarcomercio',
  PRESENTACIONES: 'presentaciones',
  TRANSACCIONES_AGRUPADAS: 'transaccionesAgrupadas',
  CARGAR_PRESENTACION: 'cargarPresentacion',
  FACTURAS_PENDIENTES: 'facturasPendientes',
  CAMBIAR_DATOS_CONTACTO: 'cambiarDatosContacto',
  CAMBIAR_PASSWORD: 'cambiarPassword',
  INSTRUCTIVOS: 'instructivos',
  UNAUTH: 'unauth'
};


export const PublicRoutes = {
  RESET_PASSWORD: `/${PCOM_ROUTES.RESET_PASSWORD}`
};

export const PrivateRoutes = {
  HOME: `/${PCOM_ROUTES.HOME}`,
  SHELL_FLOTA: `/${PCOM_ROUTES.SHELL_FLOTA}`,
  REEMBOLSO_EXPRESS: `/${PCOM_ROUTES.REEMBOLSO_EXPRESS}`,
  CAMBIAR_COMERCIO: `/${PCOM_ROUTES.CAMBIAR_COMERCIO}`,
  PRESENTACIONES: `/${PCOM_ROUTES.PRESENTACIONES}`,
  TRANSACCIONES_AGRUPADAS: `/${PCOM_ROUTES.TRANSACCIONES_AGRUPADAS}`,
  CARGAR_PRESENTACION: `/${PCOM_ROUTES.CARGAR_PRESENTACION}`,
  FACTURAS_PENDIENTES: `/${PCOM_ROUTES.FACTURAS_PENDIENTES}`,
  CAMBIAR_DATOS_CONTACTO: `/${PCOM_ROUTES.CAMBIAR_DATOS_CONTACTO}`,
  CAMBIAR_PASSWORD: `/${PCOM_ROUTES.CAMBIAR_PASSWORD}`,
  INSTRUCTIVOS: `/${PCOM_ROUTES.INSTRUCTIVOS}`,
  UNAUTH: `/${PCOM_ROUTES.UNAUTH}`
};

export const routeIncludes: (par:{path: string, url: string}) => boolean = ({path, url}) => {
  return path
    .toLocaleLowerCase()
    .includes(url.toLocaleLowerCase());
};

export const locationIncludes: (url: string) => boolean = (url) => {
  return routeIncludes({path: window.location.pathname, url});
};

export const getUrlParam: (path: string) => string | null = (path) => {
  const url = new URL(window.location.href);
  return url.searchParams.get(path);
};

export const useRemoveLocalStorage: (path: string, callback: () => any) => any = (path, callback) => {
  window.localStorage.removeItem(path);

  return callback();
};
